/** content: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "shareFolder": "Share with player groups…",
  "shareFolderTitle": "Share “{name}”",
  "shareFolderHint": "Members limited to these player groups see this folder and everything inside it, and can add to it. Everyone else sees it as before.",
  "saveSharing": "Save sharing",
  "folderShared": "Sharing of “{name}” updated",
  "sharedWithN": "Shared with {n} player group | Shared with {n} player groups",
  "fixFile": "Fix…",
  "aPreview": "Preview",
  "loadingMore": "Loading more…",
  "shownOf": "Showing {n} of {total}",
  "pvOpen": "Preview {name}",
  "pvCustomApp": "Custom apps run on the player; open it to try it.",
  "pvNotReady": "Still being prepared…",
  "pvEmpty": "Nothing to play yet.",
  "pvCantPlay": "This file can't be played here.",
  "pvPause": "Pause",
  "pvPlay": "Play",
  "pvUnmute": "Turn sound on",
  "pvMute": "Mute",
  "pvPosition": "Position",
  "pvTitle": "Preview of {name}",
  "pvTitleEmpty": "Preview",
  "pvFrame": "Screen shape",
  "pvLandscape": "Landscape",
  "pvPortrait": "Portrait",
  "pvEdit": "Edit",
  "pvClose": "Close preview",
  "pvPrev": "Previous item",
  "pvNext": "Next item",
  "pvKeys": "{n} of {total} · ← → to move between items · Esc to close",
  "type_app": "App",
  "type_playlist": "Playlist",
  "type_campaign": "Campaign",
  "type_video": "Video",
  "type_image": "Image",
  "type_pdf": "PDF",
  "type_composition": "Composition",
  "pdfLen": "PDF · {n} page · {s} s | PDF · {n} pages · {s} s each",
  "pdfs": "PDFs ({n})",
  "pdfPages": "{n} page | {n} pages",
  "pdfOpen": "Open the PDF",
  "pdfPageN": "Page {n}",
  "pdfPerPage": "Seconds per page",
  "pdfTotal": "Plays all pages in {len}",
  "pdfTurn": "Page turn",
  "pdfTurnNone": "None",
  "type_audio": "Audio",
  "colPreview": "Preview",
  "colName": "Name",
  "colType": "Type",
  "colSize": "Size",
  "colModified": "Last modified",
  "title": "Library",
  "tooLarge": "Larger than {max}",
  "noStorage": "Not enough storage left on your plan",
  "created": "{name} created",
  "appSaved": "App saved",
  "savedName": "Saved “{name}”",
  "enterNumber": "Enter a number",
  "newApp": "New App",
  "customizeApp": "Customize App · {name}",
  "fixFields": "Fix the highlighted fields first.",
  "dubai": "Dubai, UAE",
  "folderCreated": "Folder “{name}” created",
  "itsParent": "its parent",
  "deleteFolderItems": "Delete the folder “{name}”? Its {n} item will move to “{parent}”. | Delete the folder “{name}”? Its {n} items will move to “{parent}”.",
  "deleteEmptyFolder": "Delete the empty folder “{name}”?",
  "folderDeleted": "Folder “{name}” deleted",
  "quoted": "“{name}”",
  "nItems": "{n} item | {n} items",
  "movedTo": "Moved {what} to “{where}”",
  "undo": "Undo",
  "moveUndone": "Move undone",
  "tagsSaved": "Tags saved",
  "taggedN": "Tagged {n} item | Tagged {n} items",
  "tagsRestored": "Tags restored",
  "aPublish": "▶ Publish",
  "optOne": "This file is still being optimized for players. Publishing is available once it’s ready.",
  "optSome": "Some files are still being optimized for players. Publishing is available once they’re ready.",
  "optFailed": "A file could not be optimized and can’t be published. Upload it again.",
  "optHint": "Optimizing… available when ready",
  "optFailedHint": "Optimizing failed",
  "aEdit": "Edit",
  "aOpen": "Open",
  "aRename": "Rename",
  "aMove": "Move To…",
  "aTags": "Tags…",
  "aTag": "# Tag",
  "aRestriction": "Restriction…",
  "aMute": "Mute",
  "aUnmute": "Unmute",
  "mutedBadge": "Muted on every player",
  "mutedOne": "Muted “{name}” on every player",
  "unmutedOne": "Unmuted “{name}”",
  "mutedN": "Muted {n} items on every player",
  "unmutedN": "Unmuted {n} items",
  "aRestrictionOn": "Restriction 🔒…",
  "aInfo": "Information panel",
  "aUsage": "Usage",
  "aDelete": "Delete",
  "renamedTo": "Renamed to “{name}”",
  "nameRestored": "Name restored to “{name}”",
  "audioLeftOut": "Audio is played by a campaign’s Audio Track; {n} audio item(s) were left out",
  "processingLeftOut": "{n} item(s) still processing were left out",
  "viaGroup": " (via {name})",
  "viaTag": " (via tag “{tag}”)",
  "onPlayer": "On player “{name}”{via}",
  "onGroup": "On player group “{name}”",
  "inCampaign": "In campaign “{name}”",
  "inPlaylist": "In playlist “{name}”",
  "usageFailed": "Could not load usage.",
  "unpublishTagQ": "Unpublish “{name}” from tag #{tag}? It is removed from {n} player. | Unpublish “{name}” from tag #{tag}? It is removed from {n} players.",
  "unpublishedTag": "Unpublished from #{tag} ({players})",
  "nPlayers": "{n} player | {n} players",
  "nCampaigns": "{n} campaign | {n} campaigns",
  "nPlaylists": "{n} playlist | {n} playlists",
  "delTitleOne": "Delete “{name}”?",
  "delTitleMany": "Delete {n} items?",
  "delChecking": "Checking where it’s used…",
  "delUsedIn": "It’s used in:",
  "delUnused": "It isn’t used anywhere.",
  "delUnchecked": "Couldn’t check where it’s used. Deleting still takes it out of everything that uses it.",
  "delRetry": "Try again",
  "delOnPlayers": "Published on {n} player | Published on {n} players",
  "delInGroups": "Player groups: {names}",
  "delInTags": "Tags: {names}",
  "delInPlaylists": "Playlists: {names}",
  "delInCampaigns": "Campaigns: {names}",
  "delInteractions": "{n} interaction opens it (removed with it) | {n} interactions open it (removed with them)",
  "delModeDelete": "Delete",
  "delModeReplace": "Replace with…",
  "delRemovedEverywhere": "It will be taken out of all of these, as if you had removed it from each one by hand.",
  "delEmptiedTitle": "Left with nothing to show",
  "delEmptyPlaylist": "Unpublish playlist “{name}”: this was its only item",
  "delEmptyCampaign": "Unpublish campaign “{name}”: every section would be empty",
  "delEmptySections": "Unpublish campaign “{name}”: {n} section would be empty | Unpublish campaign “{name}”: {n} sections would be empty",
  "delWillUnpublish": "Taken off {n} player (kept in your library to refill later) | Taken off {n} players (kept in your library to refill later)",
  "delWillStay": "Stays published with an empty area (Health Check will remind you)",
  "delReplaceHint": "Pick what takes its place everywhere: same campaign sections, playlist positions, players and interactions, with their timings. Then it’s deleted.",
  "delReplaceAndDelete": "Replace and delete",
  "delCantUndo": "Players update right away. This can’t be undone.",
  "delCancel": "Cancel",
  "delWorking": "Working…",
  "deleteQ": "Delete {label}?",
  "deleteInUse": "Delete {label}?\n\nIt will also be removed from:\n{uses}\n\nPlayers update right away. This can’t be undone.",
  "tabProperties": "Properties",
  "tabActivity": "Activity",
  "sections": "{n} section · {tr} | {n} sections · {tr}",
  "audioPrefix": "Audio · ",
  "plItems": "{n} item · {len} | {n} items · {len}",
  "customApp": "Custom app",
  "audioLen": "Audio · {len}",
  "stPending": "Waiting to optimize",
  "stProcessing": "Optimizing",
  "stReady": "Ready",
  "stFailed": "Failed",
  "new": "New",
  "uploadFile": "Upload File",
  "folder": "Folder",
  "newCampaign": "New Campaign",
  "newPlaylist": "New Playlist",
  "uploadFiles": "Upload files",
  "storage": "Account Storage",
  "storageOf": "{used} of {max}",
  "searchContent": "Search content",
  "search": "Search",
  "typeLabel": "Type",
  "all": "All ({n})",
  "playlists": "Playlists ({n})",
  "campaigns": "Campaigns ({n})",
  "apps": "Apps ({n})",
  "videos": "Videos ({n})",
  "images": "Images ({n})",
  "audios": "Audio ({n})",
  "tag": "Tag",
  "allTags": "All tags",
  "sortBy": "Sort by",
  "sortModified": "Sort: Last modified",
  "sortName": "Sort: Name",
  "sortType": "Sort: Type",
  "view": "View",
  "asGrid": "View as grid",
  "asList": "View as list",
  "infoPanel": "Information Panel",
  "clearSelection": "Clear selection",
  "nSelected": "{n} Selected",
  "searchingAll": "Searching every folder · {n} result | Searching every folder · {n} results",
  "library": "Content library",
  "folderEmpty": "This folder is empty",
  "folderEmptyHint": "Upload or drag & drop files here, use + New, or drag cards onto this folder from elsewhere.",
  "libraryEmpty": "Your content library is empty",
  "libraryEmptyHint": "Upload images and videos, build a campaign, or add an app such as Time or Prayer Time. You can also drop files anywhere on this page.",
  "nothingMatches": "Nothing matches",
  "clearFilters": "Clear filters",
  "cardHint": "Drag onto a folder to move it · right-click for actions",
  "actionsFor": "Actions for {name}",
  "previewOf": "Preview of {name}",
  "optimizingPct": "Optimizing {pct}%",
  "waiting": "Waiting to optimize…",
  "publishedOnN": "Published on {n} player | Published on {n} players",
  "selectName": "Select {name}",
  "items": "Items",
  "nothingYet": "Nothing here yet.",
  "ofItems": "{n} of {total} items",
  "editName": "Edit {name}",
  "openName": "Open {name}",
  "closeInfo": "Close Information Panel",
  "selectToPreview": "Select an item to preview details",
  "newName": "New name",
  "notPublished": "Not published yet.",
  "tags": "Tags",
  "saveTags": "Save tags",
  "cancel": "Cancel",
  "customAttributes": "Custom attributes",
  "loading": "Loading…",
  "uPlayers": "Players ({n})",
  "uGroups": "Player groups ({n})",
  "uTags": "Tags",
  "uInside": "Inside",
  "uViaGroup": "via group {name}",
  "uViaTag": "via tag #{tag}",
  "uSelect": "Select {name}",
  "uSelectAll": "Select all",
  "uNSelected": "{n} selected",
  "uUnpublishSelected": "Unpublish from selected",
  "uOpenPlayer": "Open the player's content",
  "uGroupQuoted": "group “{name}”",
  "uPlaces": "{n} players and groups",
  "uUnpublishQ": "Unpublish “{name}” from {where}?",
  "uGroupNote": "A group removes it from the group and all its members ({n} players).",
  "uInheritedNote": "Players that got it through a group or tag lose it on that player only; the group or tag keeps it everywhere else.",
  "uUnpublished": "Unpublished “{name}” from 1 place | Unpublished “{name}” from {n} places",
  "notUsed": "Not used anywhere yet.",
  "publishedToTag": "Published to tag #{tag} · {players}",
  "unpublish": "Unpublish",
  "pType": "Type",
  "pFormat": "Format",
  "pSize": "Size",
  "pDimensions": "Dimensions",
  "pVersions": "Smaller versions",
  "versionCompat": "{p}p for older devices ({size})",
  "versionOf": "{p}p ({size})",
  "pDuration": "Duration",
  "perPass": "{len} per pass",
  "pOwner": "Owner",
  "unknown": "Unknown",
  "createdOn": "Created on",
  "lastModified": "Last modified",
  "contentId": "Content ID",
  "ownerColon": "Owner:",
  "dropToUpload": "Drop to upload",
  "dropHint": "Images, videos and PDFs · up to {max} each · a custom app as a .zip",
  "chooseApp": "Choose an app to install, then customize it.",
  "searchApps": "Search apps",
  "install": "+ Install",
  "myApps": "My apps",
  "customVersion": "Custom app · version {n}",
  "add": "+ Add",
  "noAppMatch": "No app matches “{q}”.",
  "uploadCustom": "Upload a custom app",
  "uploadCustomDesc": "Your own HTML5 app as a .zip. Drag and drop or choose a file.",
  "uploadZip": "+ Upload .zip",
  "oneZipAtATime": "One custom app at a time: the first .zip is open; drop the others after.",
  "appName": "App Name",
  "savingRecompiles": "Saving recompiles every player whose campaigns use this app.",
  "livePreview": "Live preview",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "back": "‹ Back",
  "close": "Close",
  "saving": "Saving…",
  "saveChanges": "Save changes",
  "save": "Save",
  "audioHint": "Audio plays as a campaign’s Audio Track: open a campaign and pick it under Audio Track.",
  "name": "Name",
  "renameFolder": "Rename Folder",
  "newFolder": "New Folder",
  "inFolder": "In {name}",
  "folderName": "Folder Name",
  "enterFolderName": "Enter a folder name",
  "createFolder": "Create Folder",
  "discardChanges": "You have unsaved changes. Discard them?",
  "ownedBy": "Owned by",
  "you": "You",
  "notRecorded": "Not recorded",
  "ownerHint": "Items made before owners were recorded have no owner.",
  "byPerson": "by {name}",
  "copyId": "Copy content ID",
  "idCopied": "Content ID copied",
  "pFolder": "Folder",
  "details": "Details",
  "history": "History",
  "tagNItems": "Tag {n} item | Tag {n} items",
  "bulkTagsDesc": "Adds these tags; existing tags stay.",
  "addTags": "Add tags",
  "ctxItems": "{n} items",
  "noTags": "No tags",
  "ms": "ms"
};
const ar: typeof en = {
  "shareFolder": "مشاركة مع مجموعات المشغّلات…",
  "shareFolderTitle": "مشاركة «{name}»",
  "shareFolderHint": "الأعضاء المقيّدون بهذه المجموعات يرون هذا المجلد وكل ما بداخله ويمكنهم الإضافة إليه. يراه الآخرون كما كان.",
  "saveSharing": "حفظ المشاركة",
  "folderShared": "تم تحديث مشاركة «{name}»",
  "sharedWithN": "مشترك مع مجموعة واحدة | مشترك مع {n} مجموعات",
  "fixFile": "إصلاح…",
  "aPreview": "معاينة",
  "loadingMore": "جارٍ تحميل المزيد…",
  "shownOf": "يتم عرض {n} من {total}",
  "pvOpen": "معاينة {name}",
  "pvCustomApp": "التطبيقات المخصصة تعمل على المشغل؛ افتحها لتجربتها.",
  "pvNotReady": "لا يزال قيد التجهيز…",
  "pvEmpty": "لا يوجد ما يُعرض بعد.",
  "pvCantPlay": "لا يمكن تشغيل هذا الملف هنا.",
  "pvPause": "إيقاف مؤقت",
  "pvPlay": "تشغيل",
  "pvUnmute": "تشغيل الصوت",
  "pvMute": "كتم الصوت",
  "pvPosition": "الموضع",
  "pvTitle": "معاينة {name}",
  "pvTitleEmpty": "معاينة",
  "pvFrame": "شكل الشاشة",
  "pvLandscape": "أفقي",
  "pvPortrait": "عمودي",
  "pvEdit": "تعديل",
  "pvClose": "إغلاق المعاينة",
  "pvPrev": "العنصر السابق",
  "pvNext": "العنصر التالي",
  "pvKeys": "{n} من {total} · ← → للتنقل بين العناصر · Esc للإغلاق",
  "type_app": "تطبيق",
  "type_playlist": "قائمة تشغيل",
  "type_campaign": "حملة",
  "type_video": "فيديو",
  "type_image": "صورة",
  "type_composition": "تصميم",
  "type_pdf": "PDF",
  "pdfLen": "PDF · لا صفحات | PDF · صفحة واحدة · {s} ث | PDF · صفحتان · {s} ث لكل صفحة | PDF · {n} صفحات · {s} ث لكل صفحة | PDF · {n} صفحة · {s} ث لكل صفحة | PDF · {n} صفحة · {s} ث لكل صفحة",
  "pdfs": "ملفات PDF ({n})",
  "pdfPages": "لا صفحات | صفحة واحدة | صفحتان | {n} صفحات | {n} صفحة | {n} صفحة",
  "pdfOpen": "فتح ملف PDF",
  "pdfPageN": "الصفحة {n}",
  "pdfPerPage": "ثوانٍ لكل صفحة",
  "pdfTotal": "تُعرض كل الصفحات خلال {len}",
  "pdfTurn": "تقليب الصفحات",
  "pdfTurnNone": "بدون",
  "type_audio": "صوت",
  "colPreview": "معاينة",
  "colName": "الاسم",
  "colType": "النوع",
  "colSize": "الحجم",
  "colModified": "آخر تعديل",
  "title": "المكتبة",
  "tooLarge": "أكبر من {max}",
  "noStorage": "لا توجد مساحة كافية متبقية في خطتك",
  "created": "تم إنشاء {name}",
  "appSaved": "تم حفظ التطبيق",
  "savedName": "تم حفظ «{name}»",
  "enterNumber": "أدخل رقمًا",
  "newApp": "تطبيق جديد",
  "customizeApp": "تخصيص التطبيق · {name}",
  "fixFields": "صحّح الحقول المحددة أولًا.",
  "dubai": "دبي، الإمارات",
  "folderCreated": "تم إنشاء المجلد «{name}»",
  "itsParent": "المجلد الأعلى",
  "deleteFolderItems": "حذف المجلد «{name}»؟ لا عناصر | حذف المجلد «{name}»؟ سينتقل عنصره الوحيد إلى «{parent}». | حذف المجلد «{name}»؟ سينتقل عنصراه إلى «{parent}». | حذف المجلد «{name}»؟ ستنتقل عناصره الـ{n} إلى «{parent}». | حذف المجلد «{name}»؟ سينتقل {n} عنصرًا إلى «{parent}». | حذف المجلد «{name}»؟ سينتقل {n} عنصر إلى «{parent}».",
  "deleteEmptyFolder": "حذف المجلد الفارغ «{name}»؟",
  "folderDeleted": "تم حذف المجلد «{name}»",
  "quoted": "«{name}»",
  "nItems": "لا عناصر | عنصر واحد | عنصران | {n} عناصر | {n} عنصرًا | {n} عنصر",
  "movedTo": "تم نقل {what} إلى «{where}»",
  "undo": "تراجع",
  "moveUndone": "تم التراجع عن النقل",
  "tagsSaved": "تم حفظ الوسوم",
  "taggedN": "لا عناصر | تم وسم عنصر واحد | تم وسم عنصرين | تم وسم {n} عناصر | تم وسم {n} عنصرًا | تم وسم {n} عنصر",
  "tagsRestored": "تمت استعادة الوسوم",
  "aPublish": "▶ نشر",
  "optOne": "ما زال هذا الملف قيد التحسين للمشغلات. يتاح النشر عندما يصبح جاهزًا.",
  "optSome": "ما زالت بعض الملفات قيد التحسين للمشغلات. يتاح النشر عندما تصبح جاهزة.",
  "optFailed": "تعذّر تحسين ملف ولا يمكن نشره. ارفعه مرة أخرى.",
  "optHint": "جارٍ التحسين… يتاح عند الجاهزية",
  "optFailedHint": "فشل التحسين",
  "aEdit": "تعديل",
  "aOpen": "فتح",
  "aRename": "إعادة تسمية",
  "aMove": "نقل إلى…",
  "aTags": "الوسوم…",
  "aTag": "# وسم",
  "aRestriction": "القيد…",
  "aMute": "كتم الصوت",
  "aUnmute": "إلغاء الكتم",
  "mutedBadge": "مكتوم على كل المشغلات",
  "mutedOne": "تم كتم «{name}» على كل المشغلات",
  "unmutedOne": "تم إلغاء كتم «{name}»",
  "mutedN": "تم كتم {n} عناصر على كل المشغلات",
  "unmutedN": "تم إلغاء كتم {n} عناصر",
  "aRestrictionOn": "القيد 🔒…",
  "aInfo": "لوحة المعلومات",
  "aUsage": "الاستخدام",
  "aDelete": "حذف",
  "renamedTo": "أُعيدت التسمية إلى «{name}»",
  "nameRestored": "استُعيد الاسم «{name}»",
  "audioLeftOut": "يُشغَّل الصوت عبر المسار الصوتي للحملة؛ استُبعد {n} من عناصر الصوت",
  "processingLeftOut": "استُبعد {n} من العناصر التي ما زالت قيد المعالجة",
  "viaGroup": " (عبر {name})",
  "viaTag": " (عبر الوسم «{tag}»)",
  "onPlayer": "على المشغل «{name}»{via}",
  "onGroup": "على مجموعة المشغلات «{name}»",
  "inCampaign": "في الحملة «{name}»",
  "inPlaylist": "في قائمة التشغيل «{name}»",
  "usageFailed": "تعذّر تحميل الاستخدام.",
  "unpublishTagQ": "إلغاء نشر «{name}» من الوسم #{tag}؟ | إلغاء نشر «{name}» من الوسم #{tag}؟ سيُزال من مشغل واحد. | إلغاء نشر «{name}» من الوسم #{tag}؟ سيُزال من مشغلين. | إلغاء نشر «{name}» من الوسم #{tag}؟ سيُزال من {n} مشغلات. | إلغاء نشر «{name}» من الوسم #{tag}؟ سيُزال من {n} مشغلًا. | إلغاء نشر «{name}» من الوسم #{tag}؟ سيُزال من {n} مشغل.",
  "unpublishedTag": "أُلغي النشر من #{tag} ({players})",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "nCampaigns": "لا حملات | حملة واحدة | حملتان | {n} حملات | {n} حملة | {n} حملة",
  "nPlaylists": "لا قوائم | قائمة واحدة | قائمتان | {n} قوائم | {n} قائمة | {n} قائمة",
  "delTitleOne": "حذف «{name}»؟",
  "delTitleMany": "حذف {n} عناصر؟",
  "delChecking": "جارٍ التحقق من أماكن الاستخدام…",
  "delUsedIn": "مستخدم في:",
  "delUnused": "غير مستخدم في أي مكان.",
  "delUnchecked": "تعذّر التحقق من أماكن الاستخدام. الحذف يزيله من كل ما يستخدمه على أي حال.",
  "delRetry": "حاول مرة أخرى",
  "delOnPlayers": "منشور على {n} مشغل | منشور على {n} مشغلات",
  "delInGroups": "مجموعات المشغلات: {names}",
  "delInTags": "الوسوم: {names}",
  "delInPlaylists": "قوائم التشغيل: {names}",
  "delInCampaigns": "الحملات: {names}",
  "delInteractions": "{n} تفاعل يفتحه (يُحذف معه) | {n} تفاعلات تفتحه (تُحذف معه)",
  "delModeDelete": "حذف",
  "delModeReplace": "استبدال بـ…",
  "delRemovedEverywhere": "سيُزال من كل ذلك، كما لو أزلته من كل مكان يدويًا.",
  "delEmptiedTitle": "سيصبح فارغًا",
  "delEmptyPlaylist": "إلغاء نشر قائمة التشغيل «{name}»: كان عنصرها الوحيد",
  "delEmptyCampaign": "إلغاء نشر الحملة «{name}»: ستصبح كل الأقسام فارغة",
  "delEmptySections": "إلغاء نشر الحملة «{name}»: سيصبح {n} قسم فارغًا | إلغاء نشر الحملة «{name}»: ستصبح {n} أقسام فارغة",
  "delWillUnpublish": "يُزال من {n} مشغل (يبقى في مكتبتك لتعبئته لاحقًا) | يُزال من {n} مشغلات (يبقى في مكتبتك لتعبئته لاحقًا)",
  "delWillStay": "يبقى منشورًا بمساحة فارغة (سيذكّرك فحص الحالة)",
  "delReplaceHint": "اختر ما يحل محله في كل مكان: نفس أقسام الحملات ومواضع قوائم التشغيل والمشغلات والتفاعلات بتوقيتاتها. ثم يُحذف.",
  "delReplaceAndDelete": "استبدال وحذف",
  "delCantUndo": "تتحدث المشغلات فورًا. لا يمكن التراجع عن ذلك.",
  "delCancel": "إلغاء",
  "delWorking": "جارٍ التنفيذ…",
  "deleteQ": "حذف {label}؟",
  "deleteInUse": "حذف {label}؟\n\nسيُزال أيضًا من:\n{uses}\n\nتتحدث المشغلات فورًا. لا يمكن التراجع عن ذلك.",
  "tabProperties": "الخصائص",
  "tabActivity": "النشاط",
  "sections": "لا أقسام · {tr} | قسم واحد · {tr} | قسمان · {tr} | {n} أقسام · {tr} | {n} قسمًا · {tr} | {n} قسم · {tr}",
  "audioPrefix": "صوت · ",
  "plItems": "لا عناصر · {len} | عنصر واحد · {len} | عنصران · {len} | {n} عناصر · {len} | {n} عنصرًا · {len} | {n} عنصر · {len}",
  "customApp": "تطبيق مخصص",
  "audioLen": "صوت · {len}",
  "stPending": "بانتظار التحسين",
  "stProcessing": "جارٍ التحسين",
  "stReady": "جاهز",
  "stFailed": "فشل",
  "new": "جديد",
  "uploadFile": "رفع ملف",
  "folder": "مجلد",
  "newCampaign": "حملة جديدة",
  "newPlaylist": "قائمة تشغيل جديدة",
  "uploadFiles": "رفع الملفات",
  "storage": "مساحة تخزين الحساب",
  "storageOf": "{used} من {max}",
  "searchContent": "البحث في المحتوى",
  "search": "بحث",
  "typeLabel": "النوع",
  "all": "الكل ({n})",
  "playlists": "قوائم التشغيل ({n})",
  "campaigns": "الحملات ({n})",
  "apps": "التطبيقات ({n})",
  "videos": "الفيديوهات ({n})",
  "images": "الصور ({n})",
  "audios": "الصوت ({n})",
  "tag": "الوسم",
  "allTags": "كل الوسوم",
  "sortBy": "الترتيب حسب",
  "sortModified": "الترتيب: آخر تعديل",
  "sortName": "الترتيب: الاسم",
  "sortType": "الترتيب: النوع",
  "view": "العرض",
  "asGrid": "عرض كشبكة",
  "asList": "عرض كقائمة",
  "infoPanel": "لوحة المعلومات",
  "clearSelection": "إلغاء التحديد",
  "nSelected": "{n} محدد",
  "searchingAll": "البحث في كل المجلدات · لا نتائج | البحث في كل المجلدات · نتيجة واحدة | البحث في كل المجلدات · نتيجتان | البحث في كل المجلدات · {n} نتائج | البحث في كل المجلدات · {n} نتيجة | البحث في كل المجلدات · {n} نتيجة",
  "library": "مكتبة المحتوى",
  "folderEmpty": "هذا المجلد فارغ",
  "folderEmptyHint": "ارفع الملفات أو اسحبها وأفلتها هنا، أو استخدم «+ جديد»، أو اسحب البطاقات إلى هذا المجلد من مكان آخر.",
  "libraryEmpty": "مكتبة المحتوى فارغة",
  "libraryEmptyHint": "ارفع صورًا وفيديوهات، أو أنشئ حملة، أو أضف تطبيقًا مثل الوقت أو أوقات الصلاة. يمكنك أيضًا إفلات الملفات في أي مكان من هذه الصفحة.",
  "nothingMatches": "لا توجد نتائج مطابقة",
  "clearFilters": "مسح عوامل التصفية",
  "cardHint": "اسحب إلى مجلد لنقله · انقر بزر الفأرة الأيمن للإجراءات",
  "actionsFor": "إجراءات {name}",
  "previewOf": "معاينة {name}",
  "optimizingPct": "جارٍ التحسين {pct}٪",
  "waiting": "بانتظار التحسين…",
  "publishedOnN": "غير منشور | منشور على مشغل واحد | منشور على مشغلين | منشور على {n} مشغلات | منشور على {n} مشغلًا | منشور على {n} مشغل",
  "selectName": "تحديد {name}",
  "items": "العناصر",
  "nothingYet": "لا شيء هنا بعد.",
  "ofItems": "{n} من {total} عنصر",
  "editName": "تعديل {name}",
  "openName": "فتح {name}",
  "closeInfo": "إغلاق لوحة المعلومات",
  "selectToPreview": "حدد عنصرًا لمعاينة تفاصيله",
  "newName": "الاسم الجديد",
  "notPublished": "لم يُنشر بعد.",
  "tags": "الوسوم",
  "saveTags": "حفظ الوسوم",
  "cancel": "إلغاء",
  "customAttributes": "السمات المخصصة",
  "loading": "جارٍ التحميل…",
  "uPlayers": "المشغلات ({n})",
  "uGroups": "مجموعات المشغلات ({n})",
  "uTags": "الوسوم",
  "uInside": "ضمن",
  "uViaGroup": "عبر المجموعة {name}",
  "uViaTag": "عبر الوسم #{tag}",
  "uSelect": "تحديد {name}",
  "uSelectAll": "تحديد الكل",
  "uNSelected": "تم تحديد {n}",
  "uUnpublishSelected": "إلغاء النشر من المحدد",
  "uOpenPlayer": "فتح محتوى المشغل",
  "uGroupQuoted": "المجموعة «{name}»",
  "uPlaces": "{n} من المشغلات والمجموعات",
  "uUnpublishQ": "إلغاء نشر «{name}» من {where}؟",
  "uGroupNote": "المجموعة: يُزال من المجموعة ومن جميع أعضائها ({n} مشغلات).",
  "uInheritedNote": "المشغلات التي حصلت عليه عبر مجموعة أو وسم تفقده على ذلك المشغل فقط؛ وتبقيه المجموعة أو الوسم في كل مكان آخر.",
  "uUnpublished": "تم إلغاء نشر «{name}» من {n} أماكن | تم إلغاء نشر «{name}» من مكان واحد | تم إلغاء نشر «{name}» من مكانين | تم إلغاء نشر «{name}» من {n} أماكن | تم إلغاء نشر «{name}» من {n} مكانًا | تم إلغاء نشر «{name}» من {n} مكان",
  "notUsed": "غير مستخدم في أي مكان بعد.",
  "publishedToTag": "منشور على الوسم #{tag} · {players}",
  "unpublish": "إلغاء النشر",
  "pType": "النوع",
  "pFormat": "الصيغة",
  "pSize": "الحجم",
  "pDimensions": "الأبعاد",
  "pVersions": "نسخ أصغر",
  "versionCompat": "{p}p للأجهزة القديمة ({size})",
  "versionOf": "{p}p ({size})",
  "pDuration": "المدة",
  "perPass": "{len} لكل دورة",
  "pOwner": "المالك",
  "unknown": "غير معروف",
  "createdOn": "تاريخ الإنشاء",
  "lastModified": "آخر تعديل",
  "contentId": "معرّف المحتوى",
  "ownerColon": "المالك:",
  "dropToUpload": "أفلت للرفع",
  "dropHint": "صور وفيديوهات وملفات PDF · حتى {max} لكل ملف · تطبيق مخصص بصيغة ‎.zip‎",
  "chooseApp": "اختر تطبيقًا لتثبيته، ثم خصّصه.",
  "searchApps": "البحث في التطبيقات",
  "install": "+ تثبيت",
  "myApps": "تطبيقاتي",
  "customVersion": "تطبيق مخصص · الإصدار {n}",
  "add": "+ إضافة",
  "noAppMatch": "لا يوجد تطبيق يطابق «{q}».",
  "uploadCustom": "رفع تطبيق مخصص",
  "uploadCustomDesc": "تطبيق HTML5 خاص بك بصيغة ‎.zip‎. اسحبه وأفلته أو اختر ملفًا.",
  "uploadZip": "+ رفع ‎.zip‎",
  "oneZipAtATime": "تطبيق مخصص واحد في كل مرة: تم فتح أول ملف ‎.zip‎، أفلت الملفات الأخرى بعده.",
  "appName": "اسم التطبيق",
  "savingRecompiles": "يعيد الحفظ تجميع كل مشغل تستخدم حملاته هذا التطبيق.",
  "livePreview": "معاينة مباشرة",
  "landscape": "أفقي",
  "portrait": "عمودي",
  "back": "رجوع ›",
  "close": "إغلاق",
  "saving": "جارٍ الحفظ…",
  "saveChanges": "حفظ التغييرات",
  "save": "حفظ",
  "audioHint": "يُشغَّل الصوت كمسار صوتي للحملة: افتح حملة واختره من «المسار الصوتي».",
  "name": "الاسم",
  "renameFolder": "إعادة تسمية المجلد",
  "newFolder": "مجلد جديد",
  "inFolder": "في {name}",
  "folderName": "اسم المجلد",
  "enterFolderName": "أدخل اسم المجلد",
  "createFolder": "إنشاء مجلد",
  "discardChanges": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
  "ownedBy": "المالك",
  "you": "أنت",
  "notRecorded": "غير مسجّل",
  "ownerHint": "العناصر المُنشأة قبل تسجيل المالكين ليس لها مالك.",
  "byPerson": "بواسطة {name}",
  "copyId": "نسخ معرّف المحتوى",
  "idCopied": "تم نسخ معرّف المحتوى",
  "pFolder": "المجلد",
  "details": "التفاصيل",
  "history": "السجل",
  "tagNItems": "وسم العناصر | وسم عنصر واحد | وسم عنصرين | وسم {n} عناصر | وسم {n} عنصرًا | وسم {n} عنصر",
  "bulkTagsDesc": "يضيف هذه الوسوم؛ وتبقى الوسوم الحالية.",
  "addTags": "إضافة الوسوم",
  "ctxItems": "{n} عناصر",
  "noTags": "لا وسوم",
  "ms": "ملّي ث"
};
export default { en, ar };
